<script>
import findIndex from 'lodash.findindex'
import DropDown from '~/components/common/DropDown'
import GameSelect from '~/components/logic-common/GameSelect'
import AreaSelect from '~/components/logic-common/AreaSelect'
export default {
  components: {
    DropDown,
    GameSelect,
    AreaSelect
  },
  props: {
    showRole: {
      type: Boolean,
      default: true
    },
    bindGames: {
      type: Array,
      default: () => []
    },
    showLastPlayedGame: {
      type: Boolean,
      default: true
    },
    dir: {
      type: String,
      default: 'horizontal'
    },
    filterPayStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      serverList: [],
      roleList: [],
      playedGames: [],
      playedArea: [],
      curGameIndex: -1,
      curAreaIndex: -1,
      curRoleIndex: -1,
      showAreaBoard: false,
      showGameBoard: false
    }
  },
  computed: {
    curGame() {
      return this.serverList[this.curGameIndex] || {}
    },
    curArea() {
      return this.areaList[this.curAreaIndex] || {}
    },
    curRole() {
      return this.roleList[this.curRoleIndex] || {}
    },
    areaList() {
      return this.curGame.server_list || []
    },
    gameStyle() {
      if (this.bindOneGame) {
        return {
          pointerEvents: 'none',
          cursor: 'default'
        }
      }
      return {}
    },
    sizeStyle() {
      return {
        width: (this.showRole ? 500 : 340) + 'px'
      }
    },
    bindOneGame() {
      return this.bindGames.length === 1
    },
    showAll() {
      return !this.bindGames.length || +this.bindGames[0] === 0
    }
  },
  watch: {
    bindGames(val) {
      this.clientCreated()
    }
  },
  methods: {
    clientCreated() {
      this.fetchServerList().then(() => {
        if (this.bindOneGame) {
          this.changeCurGame(this.bindGames[0])
        }
      })
      if (this.showLastPlayedGame && $nuxt.$store.getters.isLogin) {
        this.fetchPlayedGame()
      }
    },
    fetchServerList() {
      return $nuxt.$store.dispatch('app/getServerList').then((data = []) => {
        const arr =
          this.bindOneGame || this.showAll
            ? data
            : data.filter((e) => this.bindGames.includes(e.game_id))
        const arr1 = this.filterPayStatus
          ? arr.filter((e) => this.$util.getPayStatus(e.pay_status))
          : arr
        this.serverList = arr1.map((e, i) => ({ ...e, index: i }))
      })
    },
    fetchPlayedGame() {
      return $nuxt.$request('gameRecently').then((data = []) => {
        this.playedGames = this.filterPayStatus
          ? data.filter((e) => this.$util.getPayStatus(e.pay_status))
          : data
      })
    },
    fetchPlayedArea(game_id) {
      return $nuxt
        .$request('gameRecently', {
          body: { game_id }
        })
        .then((data = [{}]) => {
          this.playedArea = data[0].latest_server_list || []
        })
    },
    fetchRole() {
      $nuxt
        .$request('gameRole', {
          body: {
            account: '',
            game_id: this.curGame.game_id,
            server_id: this.curArea.server_id,
            client_type: this.$util.getClientType()
          }
        })
        .then((data = {}) => {
          if (!data.role_list || !data.role_list.length) {
            return Promise.reject(new Error('未查询到角色信息'))
          }
          this.roleList = data.role_list || []
          this.curRoleIndex = data.role_list.length === 1 ? 0 : -1
        })
        .catch((err) => this.$notify(err.message))
    },
    changeCurGame(game_id) {
      const cur = this.serverList.filter((e) => e.game_id === game_id)[0]
      this.changeGameIndex(cur.index)
      this.fetchPlayedArea(cur.game_id)

      if (!this.bindOneGame) {
        this.lazyToggle(true)
      }
    },
    changeCurArea(area) {
      const index = findIndex(
        this.areaList,
        (e) => e.server_id === area.server_id
      )
      this.changeAreaIndex(index)
      this.showRole && this.fetchRole()
    },
    changeGameIndex(index) {
      this.curGameIndex = index
      this.curAreaIndex = this.curRoleIndex = -1
      this.roleList = []
    },
    changeAreaIndex(index) {
      this.curAreaIndex = index
      this.curRoleIndex = -1
      this.roleList = []
    },
    lazyToggle(flag) {
      // for areaselect show board
      setTimeout(() => {
        this.showAreaBoard = true
      }, 0)
    }
  },
  render() {
    const isHor = this.dir === 'horizontal'
    const GameComp = (
      <GameSelect
        class={{ mr10: isHor }}
        list={this.serverList}
        placeholder="选择游戏"
        curGame={this.curGame}
        playedGames={this.playedGames}
        style={this.gameStyle}
        on-change={($event) => this.changeCurGame($event.game_id)}
      />
    )
    const AreaComp = (
      <AreaSelect
        class={{ mr10: isHor }}
        list={this.areaList}
        placeholder="选择区服"
        curArea={this.curArea}
        playedArea={this.playedArea}
        selecting={this.showAreaBoard}
        on-change={($event) => this.changeCurArea($event)}
        on-toggle={($event) => (this.showAreaBoard = $event)}
      />
    )
    const RoleComp = (
      <DropDown
        list={this.roleList}
        placeholder="选择角色"
        labelKey="role_name"
        defIndex={this.curRoleIndex}
        selecting={this.showAreaBoard}
        on-change={($event) => (this.curRoleIndex = $event)}
      />
    )
    if (isHor) {
      return (
        <div class="cp-selectRole_horizontal" style={this.sizeStyle}>
          {GameComp}
          {AreaComp}
          {this.showRole ? RoleComp : null}
        </div>
      )
    }
    return (
      <div class="cp-selectRole_vertical">
        <div class="cp-selectRole_vertical-line">
          <label>请选择游戏</label>
          {GameComp}
        </div>
        <div class="cp-selectRole_vertical-line">
          <label>请选择区服</label>
          {AreaComp}
        </div>
        {this.showRole ? (
          <div class="cp-selectRole_vertical-line">
            <label>游戏角色名</label>
            {RoleComp}
          </div>
        ) : null}
      </div>
    )
  }
}
</script>

<style lang="scss">
.cp-selectRole {
  &_vertical {
    &-line {
      margin-bottom: 20px;
      label {
        font-size: 14px;
        color: #7e8aa5;
        vertical-align: middle;
        margin-right: 20px;
      }
    }
  }
}
</style>
